module.exports = __webpack_public_path__ + "img/mb_hm_block03_03_sc.20326e44.png";